

import styled from 'styled-components';

import { colors, fonts } from '../../shared/tokens';
import { Section } from '../landingShared';

const STATS = [
  { value: '500+', label: 'Active monitored sites' },
  { value: '99.9%', label: 'Platform uptime SLA' },
  { value: '24/7', label: 'Real-time monitoring' },
  { value: '12+', label: 'Years industrial expertise' },
  { value: '3', label: 'Heating system product lines' },
];

const Stats = () => (
  <Section>
    <Strip>
      {STATS.map((s, i) => (
        <Item key={s.label} $first={i === 0}>
          <Value>{s.value}</Value>
          <Label>{s.label}</Label>
        </Item>
      ))}
    </Strip>
  </Section>
);

export default Stats;

const Strip = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  padding: 0.75px 50px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  border-top: 0.75px solid ${colors.hairline};
  border-bottom: 0.75px solid ${colors.hairline};

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 0;
    padding: 32px 24px;
  }
  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

const Item = styled.div`
  padding: 16px 0 16px 32px;
  ${({ $first }) => !$first && `border-left: 0.75px solid ${colors.hairline};`}

  @media (max-width: 768px) {
    border-left: none;
    padding-left: 0;
    text-align: center;
  }
`;

const Value = styled.p`
  font-family: ${fonts.condensed};
  font-weight: 800;
  font-size: 34px;
  line-height: 38px;
  color: ${colors.cyan};
`;

const Label = styled.p`
  margin-top: 2px;
  font-family: ${fonts.body};
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${colors.muted};
`;
